import React from 'react';
import classNames from 'classnames/bind';
import { Button } from '@components';
import { Modal } from 'gd-design-library';

import styles from './FiltersModal.module.scss';

const cx = classNames.bind(styles);
const CN = 'filters-modal';
const footerButtonClassName = cx(`${CN}__footer-button`);

interface FiltersModalProps {
  isOpen: boolean;
  onClose: () => void;
  onClearAll: () => void;
  children: React.ReactNode;
  title?: string;
}

export const FiltersModal: React.FC<FiltersModalProps> = ({
  isOpen,
  onClose,
  onClearAll,
  children,
  title = 'Filters'
}) => (
  <Modal
    isOpen={ isOpen }
    onClose={ onClose }
    title={ title }
    closeOnEscape
    className={ cx(CN) }
    footer={
      <>
        <Button
          variant='outlined'
          onClick={ onClearAll }
          className={ footerButtonClassName }
        >
          Clear All
        </Button>
        <Button
          variant='primary'
          onClick={ onClose }
          className={ footerButtonClassName }
        >
          Apply Filters
        </Button>
      </>
    }
  >
    {children}
  </Modal>
);
